/**
 * @auger/google — the Google Calendar and Gmail REST APIs. It knows nothing of
 * Auger: each interface creates one with the caller's access token.
 *
 *   const google = createGoogle({ token: () => store.token?.token })
 *   await google.calendar.events.list({ timeMin, timeMax })
 *   await google.gmail.threads.list({ q: "from:ada@example.com" })
 */
import { createCalendar } from "./calendar.js"
import { createApi, type GoogleOptions } from "./client.js"
import { createGmail } from "./gmail.js"

export function createGoogle(options: GoogleOptions) {
  const api = createApi(options)
  return { calendar: createCalendar(api), gmail: createGmail(api) }
}

export type Google = ReturnType<typeof createGoogle>

export {
  GoogleError,
  GoogleNotConnected,
  type GoogleOptions,
  type TokenSource,
} from "./client.js"
export * from "./calendar.js"
export * from "./gmail.js"
export * from "./parse.js"
